import { createFileRoute, redirect } from '@tanstack/react-router';

/** 매칭되지 않는 모든 경로는 랜딩으로 리다이렉트 (기존 catch-all 대응) */
export const Route = createFileRoute('/$')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
